import React from "react";

// ASSETS
import CloseIcon from "assets/svg/XSignGrey.svg";
// STYLES
import {
  ModalContainer,
  Backdrop,
  ModalCloseButtonWrapper,
  ModalCloseButton,
  ModalContent,
} from "./ModalStyled";

// LIBRARIES

// MISC
import { IProps, ModalTypes } from "./ModalModel";

// REDUX

// COMPONENTS
import PartnerDetails from "./ModalContent/PartnerDetails/PartnerDetails";
import TeamDetails from "./ModalContent/TeamDetails/TeamDetails";

const Modal = (props: IProps) => {
  // PROPERTIES
  const {
    type = "",
    isVisible = false,
    onClose = () => {},
    item = null,
  } = props;
  // LIBRARY CONSTANTS

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const handleBackdropClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleRenderContent = () => {
    switch (type) {
      case ModalTypes.PARTNERS:
        return <PartnerDetails item={item} />;
      case ModalTypes.TEAM:
        return <TeamDetails item={item} />;
      case ModalTypes.NONE:
      default:
        return null;
    }
  };

  return (
    <Backdrop open={isVisible} onClick={handleBackdropClick}>
      <ModalContainer>
        <ModalCloseButtonWrapper onClick={onClose}>
          <ModalCloseButton src={CloseIcon} />
        </ModalCloseButtonWrapper>
        <ModalContent open={isVisible} onClick={(e) => e.stopPropagation()}>
          {handleRenderContent()}
        </ModalContent>
      </ModalContainer>
    </Backdrop>
  );
};

export default Modal;
